import { View } from 'backbone.marionette';

import formatAsDollars from '@/util/formatAsDollars';

import tmplVB0DeviceItemView from './VB0DeviceItemView.hbs';

const VB0DeviceItemView = View.extend({
  template: tmplVB0DeviceItemView,

  className: 'order-device-item-view pt-2 pb-4 px-4',

  ui: {
    price: '.price',
    quantity: '.quantity',
    formattedTotalPrice: '.item-total-cost',
    inputNumberDevices: '.input-number-devices'
  },

  events: {
    'change @ui.quantity': 'onQuantityChange'
  },

  initialize() {
    this.model.set({
      totalPrice: this.model.get('totalPrice') || '0',
      formattedTotalPrice: formatAsDollars(this.model.get('totalPrice') || 0),
      quantity: this.model.get('quantity') || '0'
    });
  },

  onQuantityChange(e) {
    const quantity = this.ui.quantity.val();
    const totalPrice = this.model.get('price') * quantity;
    this.ui.formattedTotalPrice.text(formatAsDollars(totalPrice));
    this.model.set('quantity', quantity);
    this.model.set('totalPrice', totalPrice);
  }
});

export default VB0DeviceItemView;
